import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import throttle from 'lodash/throttle';
export var DISTANCE_UNIT;
(function(DISTANCE_UNIT) {
    DISTANCE_UNIT["PX"] = "PX";
    DISTANCE_UNIT["WINDOW_HEIGHT"] = "WINDOW_HEIGHT";
})(DISTANCE_UNIT || (DISTANCE_UNIT = {}));
const THROTTLE_TIMEOUT = 250;
class OnScrollBottom extends React.Component {
    componentDidMount() {
        window && window.addEventListener('scroll', this.callOnScrolledToBottom);
        if (this.props.checkOnMount) {
            this.callOnScrolledToBottom();
        }
    }
    componentDidUpdate() {
        if (this.props.checkOnUpdate) {
            this.callOnScrolledToBottom();
        }
    }
    componentWillUnmount() {
        window && window.removeEventListener('scroll', this.callOnScrolledToBottom);
    }
    render() {
        const { children } = this.props;
        if (!children) {
            return null;
        }
        return /*#__PURE__*/ React.cloneElement(children, {
            ref: this.childNodeRef
        });
    }
    getDistanceToBottomWhenShouldTrigger() {
        const { distanceToBottom, distanceUnit } = this.props;
        if (distanceUnit === "PX") {
            return distanceToBottom;
        }
        return distanceToBottom * window.innerHeight;
    }
    getDistanceToBottom() {
        const { children } = this.props;
        if (children) {
            const childNode = this.childNodeRef.current;
            if (!childNode) {
                return 0;
            }
            // this child bottom position is relative to the top of the view port
            const childBottom = childNode.getBoundingClientRect().bottom;
            // we are interestedin the distance from the bottom of the view port to the child bottom
            const distanceToChildBottom = childBottom - window.innerHeight;
            return distanceToChildBottom;
        }
        const distanceToScrollContainerBottom = window.document.body.scrollHeight - window.scrollY - window.innerHeight;
        return distanceToScrollContainerBottom;
    }
    constructor(...args){
        super(...args);
        _define_property(this, "prevScrollTop", void 0);
        _define_property(this, "childNodeRef", /*#__PURE__*/ React.createRef());
        _define_property(this, "rememberScrollTop", ()=>{
            this.prevScrollTop = window.scrollY;
        });
        _define_property(this, "callOnScrolledToBottom", throttle(()=>requestAnimationFrame(()=>{
                const { onScrolledToBottom } = this.props;
                if (!onScrolledToBottom) {
                    return;
                }
                if (!window.document.body.scrollHeight) {
                    return;
                }
                if (this.getDistanceToBottom() <= this.getDistanceToBottomWhenShouldTrigger()) {
                    const scrollDelta = window.scrollY - this.prevScrollTop || 0;
                    onScrolledToBottom(scrollDelta);
                }
                this.rememberScrollTop();
            }), THROTTLE_TIMEOUT));
    }
}
export default OnScrollBottom;

//# sourceMappingURL=OnScrollBottom.js.map